// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__qIW87","list-default":"styles_list-default__pgR23"};